import React from "react";

/**
 * Blank space the height of the on-screen keyboard, sat between the last
 * question and the bar at the foot of a form.
 *
 * Nothing at all until a keyboard is up — `--keyboard-inset` is zero the rest
 * of the time, which is every desktop and every screen of both forms that has
 * nothing to type into. See `useKeyboardAvoidance`, which sets it.
 *
 * It exists for the bar rather than for the fields. Both forms end in one that
 * is `sticky bottom-0`, and a sticky element can only travel as far as the
 * bottom of the box it sits in: run out of form and it stops, wherever that
 * happens to be. Scroll a step far enough to lift its last field clear of the
 * keyboard and that is exactly what happens — the form ends mid-screen, the
 * bar stops there with it, and it comes to rest in the strip of glass directly
 * above the keyboard. Which is the one place it must not be, because it is
 * where the field being typed into has just been put.
 *
 * A keyboard's worth of empty page below the last question is enough form left
 * for the bar to keep sliding, so it stays pinned to the bottom edge — under
 * the keyboard, out of sight, exactly where a native app puts it — and comes
 * back the moment the keyboard goes down.
 *
 * `flex-shrink-0` because the pre-consultation form is a flex column and would
 * otherwise squeeze this back to nothing, which is the whole of what it is.
 */
const KeyboardSpacer: React.FC = () => (
  <div aria-hidden="true" className="h-[var(--keyboard-inset,0px)] flex-shrink-0" />
);

export default KeyboardSpacer;
